import { Component, Input, OnChanges, signal, ViewEncapsulation } from '@angular/core';
import { MultiShipmentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { ViewMode } from '../../../../models';
import { BANNER_STYLE_TO_VARIANT, PREVIEW_MAX_ENTRIES } from './multi-shipment-example.model';

type PreviewTab = 'info' | 'order-summary' | 'modal';

@Component({
  selector: 'multi-shipment-example',
  templateUrl: './multi-shipment-example.component.html',
  styleUrls: ['./multi-shipment-example.component.scss'],
  standalone: false,
})
export class MultiShipmentExampleComponent implements OnChanges {
  @Input() template: MultiShipmentExtension.Template;
  @Input() mode: ViewMode = null;
  @Input() isMobile = false;

  readonly tabs: { label: string; value: PreviewTab }[] = [
    { label: 'Info Section', value: 'info' },
    { label: 'Order Summary', value: 'order-summary' },
    { label: 'Recipient modal', value: 'modal' },
  ];
  readonly activeTab = signal<PreviewTab>('info');

  contactBannerTone: BannerVariant['variant'] = 'info';
  deliveryBannerTone: BannerVariant['variant'] = 'info';
  readonly shippingMode = signal<MultiShipmentExtension.ShippingMode>('single');
  readonly recipientCount = signal(0);
  readonly giftNoteCount = signal(0);

  private defaultSelection: MultiShipmentExtension.ShippingMode;

  ngOnChanges(): void {
    const defaultSelection = this.template?.shippingToggle?.defaultSelection ?? 'single';
    if (defaultSelection !== this.defaultSelection) {
      this.defaultSelection = defaultSelection;
      this.shippingMode.set(defaultSelection);
    }

    this.contactBannerTone = (
      BANNER_STYLE_TO_VARIANT[this.template?.contactSectionBanner?.style] ?? BANNER_STYLE_TO_VARIANT.info
    ).variant;
    this.deliveryBannerTone = (
      BANNER_STYLE_TO_VARIANT[this.template?.deliverySectionBanner?.style] ?? BANNER_STYLE_TO_VARIANT.info
    ).variant;
  }

  addRecipient(): void {
    this.recipientCount.update((count) => Math.min(count + 1, PREVIEW_MAX_ENTRIES));
  }

  removeRecipient(): void {
    this.recipientCount.update((count) => Math.max(count - 1, 0));
  }

  addGiftNote(): void {
    this.giftNoteCount.update((count) => Math.min(count + 1, PREVIEW_MAX_ENTRIES));
  }

  removeGiftNote(): void {
    this.giftNoteCount.update((count) => Math.max(count - 1, 0));
  }
}

type BannerVariant = (typeof BANNER_STYLE_TO_VARIANT)[keyof typeof BANNER_STYLE_TO_VARIANT];
